import React, { PropsWithChildren, ReactElement } from "react";
import { Text, Stack, StackProps, Center, TextProps } from "@chakra-ui/react";

export const ErrorLoadingInline = (props: TextProps): ReactElement => (
  <Text
    as="em"
    fontSize="sm"
    textColor="warningRed"
    fontWeight="normal"
    {...props}
  >
    Error Loading
  </Text>
);

const ErrorLoading = ({
  message: message,
  children,
  ...rest
}: PropsWithChildren<{ message: string } & StackProps>): ReactElement => {
  return (
    <Center minHeight="400px" w="100%">
      <Stack spacing={4} align="center" {...rest}>
        <Text textStyle="h1">Failed to load</Text>
        <Text textAlign="center">{message}</Text>
        {children}
      </Stack>
    </Center>
  );
};

export default ErrorLoading;
